import LoadableAddToHubModal from './LoadableAddToHubModal';

export default LoadableAddToHubModal;
